import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthorizeUrlResponse } from '../interfaces/api-response.interface';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class Au10tixService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.apiUrl;

  getAuthorizeUrl(): Observable<AuthorizeUrlResponse> {
    return this.http.get<AuthorizeUrlResponse>(`${this.apiUrl}/mobile/authorize-url`);
  }
}

